<template>
  <b-container>
    <manifest-item :id="id" />
  </b-container>
</template>
<script>
import ManifestItem from '@/components/ManifestItem'

export default {
  name: 'ManifestsItemPage',
  components: {
    ManifestItem
  },
  props: {
    id: {
      type: String,
      default: null
    }
  }
}
</script>
